
const heroSectionData = {
    title : "Our Approach To ESG",
    subtitle : "We firmly believe that SAB has a unique role in society, and that we can spearhead transformational change in the Kingdom",
}

export default heroSectionData;